<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户</label>
            <span class="weui-form-preview__value">{{initData.custname}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">月份</label>
            <span class="weui-form-preview__value">{{initData.yearmonth}}</span>
          </div>
        </div>
      </div>
      <!-- <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd form-detail-preview" v-for="(item, index) in form.items" :key="item.id">
          <div class="form-detail-preview_num">{{index + 1}}</div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据类型</label>
            <span class="weui-form-preview__value">{{sbd_source_type(item.sbd_source_type)}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">来源单号</label>
            <span class="weui-form-preview__value">{{item.sbd_source_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户PO号</label>
            <span class="weui-form-preview__value">{{item.sbd_source_cust_po_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户料号</label>
            <span class="weui-form-preview__value">{{item.sbd_source_cust_pr_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">出入库单号</label>
            <span class="weui-form-preview__value">{{item.sbd_pi_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">行号</label>
            <span class="weui-form-preview__value">{{item.sbd_pi_pd_detno}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">出入库数量</label>
            <span class="weui-form-preview__value">{{item.sbd_pi_qty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">出入库日期</label>
            <span class="weui-form-preview__value">{{item.sbd_pi_date}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单价</label>
            <span class="weui-form-preview__value">{{numberFormat(item.sbd_source_price,'#,##0.00')}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">出入库金额</label>
            <span class="weui-form-preview__value">{{numberFormat(item.sbd_pi_total,'#,##0.00')}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">币别</label>
            <span class="weui-form-preview__value">{{item.sbd_currency}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料编号</label>
            <span class="weui-form-preview__value">{{item.sbd_pr_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料名称</label>
            <span class="weui-form-preview__value">{{item.sbd_pr_detail}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">规格</label>
            <span class="weui-form-preview__value">{{item.sbd_pr_spec}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">厂家/品牌</label>
            <span class="weui-form-preview__value">{{item.sbd_pr_brand}}</span>
          </div>
        </div>
      </div>
      <div class="form-preview weui-form-preview" v-if="form.purchaseBillDetailList">
        <div class="weui-form-preview__bd form-detail-preview" v-for="(item, index) in form.purchaseBillDetailList" :key="item.id">
          <div class="form-detail-preview_num">{{index + 1}}</div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据类型</label>
            <span class="weui-form-preview__value">{{bd_source_type(item.bd_source_type)}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">来源单号</label>
            <span class="weui-form-preview__value">{{item.bd_source_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">出入库单号</label>
            <span class="weui-form-preview__value">{{item.bd_pi_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">行号</label>
            <span class="weui-form-preview__value">{{item.bd_pi_pd_detno}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">收料数量</label>
            <span class="weui-form-preview__value">{{item.bd_iqc_qty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">验退数量</label>
            <span class="weui-form-preview__value">{{item.bd_iqc_ngqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">出入库数量</label>
            <span class="weui-form-preview__value">{{item.bd_pi_qty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">出入库日期</label>
            <span class="weui-form-preview__value">{{item.bd_pi_date}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单价</label>
            <span class="weui-form-preview__value">{{numberFormat(item.bd_source_price,'#,##0.00')}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">出入库金额</label>
            <span class="weui-form-preview__value">{{numberFormat(item.bd_pi_total,'#,##0.00')}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">币别</label>
            <span class="weui-form-preview__value">{{item.bd_currency}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料编号</label>
            <span class="weui-form-preview__value">{{item.bd_pr_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料名称</label>
            <span class="weui-form-preview__value">{{item.bd_pr_detail}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">规格</label>
            <span class="weui-form-preview__value">{{item.bd_pr_spec}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">厂家/品牌</label>
            <span class="weui-form-preview__value">{{item.bd_pr_brand}}</span>
          </div>
        </div>
      </div> -->
    </div>
    <!-- <div class="footer-bar weui-dialog__ft">
      <share class="weui-dialog__btn weui-dialog__btn_default" v-if="!editable" :biz-data="bizData"></share>
    </div> -->
  </div>
</template>

<script>
// import Share from "@/components/button/Share.vue";

export default {
  props: {
    initData: Object
  },
  components: {
    // Share
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.requestList();
    })
  },
  data() {
    return {
      listUrl: "/api/sale/saleBill/detailByMonth",
      result: {}
    };
  },
  computed: {
    bizData() {
      var main = this.form.main;
      if (!main) {
        return null;
      }
      return {
        // bizCode: main.pu_code,
        bizType: "SaleBill",
        bizId: main.id,
        viewType: "sale-saleBill-querypanel-detail",
        title: "销售对账明细表" + main.sbm_year_month,
      };
    },
  },
  methods: {
    requestList() {
      var me = this
      
      let yearmonth = me.initData.yearmonth + '',
        year = yearmonth.substring(0, 4),
        monthStr = yearmonth.substring(4, 6),
        month

      if(monthStr[0] == 0) {
        month = Number(monthStr[1]) - 1
      } else {
        month = Number(monthStr) - 1
      }

      let lastDate = new Date(year, month + 1, 0).getDate()

      let start = `${year}-${monthStr}-01 00:00:00`
      let end = `${year}-${monthStr}-${lastDate} 00:00:00`
      
      let jsonData = {
        currency: me.initData.currency,
        custname: me.initData.custname,
        custid: me.initData.custid,
        year: me.initData.year,
        yearmonth: me.initData.yearmonth,
        start,
        end
      }

      me.$loading({
          url: me.listUrl,
          method: 'POST',
          jsonData
      }).then(function (res) {
        if (res.success) {
          me.result = res.data;
        } else {
          me.$router.push({
            name: "Error",
            params: res
          });
        }
      });
    },
    sbd_source_type(type) {
      type = type.toUpperCase()
      if(type == 'SALEOUT'){
        type = "销售出货";
      } else if (type == 'SALERETURN'){
        type = "销售退货";
      } else if (type == 'OthReceivables'){
        type = "应收调账单";
      }
      return type;
    },
    bd_source_type(type) {
      type = type.toUpperCase()
      if(type == 'OSMAKEIN'){
        type = "外协入库";
      } else if (type == 'OSMAKEINBACK'){
        type = "外协退货";
      } else if (type == 'OthPayables'){
        type = "应付调账单";
      } else if (type == 'PURCOUT'){
        type = "采购退货";
      } else if (type == 'PURCIN'){
        type = "采购入库"
      }
      return type;
    }
  }
}
</script>